// extracted by mini-css-extract-plugin
module.exports = {"notificationCenter":"notification-center-element_notificationCenter__3N6j2"};